import { 
  DELETE_RESERVATION_DELETE, 
  PENDING, FULFILLED, REJECTED 
} from '../globals';

export const initialState = {
  isLoading: true,
  status: false,
  error: false,
  errorType: {
    time: true,
    completed: true,
    deleted: true,
    emailConfirmed: true,
  },
};

const reducer = (state = initialState, action) => {
  const { type, payload, } = action;

  switch (type) {
    case `${DELETE_RESERVATION_DELETE}_${PENDING}`:
      return {
        ...initialState,
        isLoading: true,
      };

    case `${DELETE_RESERVATION_DELETE}_${FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        status: true,
        error: false,
      };

    case `${DELETE_RESERVATION_DELETE}_${REJECTED}`: 
      return {
        ...state,
        isLoading: false,
        status: false,
        error: true,
        errorType: payload,
      };
    
    default:
      return state;
  }
};

export default reducer;